import { useMemo, useCallback, useContext } from 'react';
import { makeStyles } from '@ellucian/react-design-system/core';
import { useIntl } from 'react-intl';
import useApplicationForm from '../../useApplicationForm';
import { useRouteMatch, useLocation } from 'react-router-dom';
import { routes } from '../../../Helpers/Configuration';
import { colorGlobalBorderDefault, spacing40, spacing30 } from '@ellucian/react-design-system/core/styles/tokens';
import { useSelector } from 'react-redux';
import { createDisableNavigationSelector } from '../../redux/actions/navigationActions';
import GlobalLocaleContext from '../../../GlobalLocale/GlobalLocaleContext';
import { findNextAvailablePageId, findPreviousAvailablePageId } from '../../../Helpers/ApplicationHelpers';
import { IconButton } from '@ellucian/react-design-system/core';
import { Icon } from '@ellucian/ds-icons/lib';

const useStyles = makeStyles({
    name: 'InquiryNavigation'
})(() => ({
    navButtonSpacing: {
        marginBottom: spacing40,
        border: `0.063rem solid ${colorGlobalBorderDefault}`,
        marginRight: spacing30,
    },
}));
const selectHiddenPageIds = state => state.settings.hiddenPageIds;

const InquiryNavigation = props => {
    const intl = useIntl();
    const {
        onBack: onBackProp,
        onContinue: onContinueProp,
    } = props;
    const { classes } = useStyles();
    const {
        template,
    } = useApplicationForm();
    const { localeDirection } = useContext(GlobalLocaleContext);
    const location = useLocation();
    const disableNavigationSelector = useMemo(createDisableNavigationSelector, []);
    const disableNavigation = useSelector(
        state => disableNavigationSelector(state, location.pathname)
    );
    const hiddenPageIds = useSelector(selectHiddenPageIds);
    const match = useRouteMatch({
        path: [
            routes.adminTemplatePreviewPageById,
            routes.applicationFormPageById,
            routes.externalApplicationPageById,
        ],
    });

    const nextAvailablePageId = useMemo(() => {
        const pageId = match ? match.params.pageId : null;
        return findNextAvailablePageId(pageId, template?.pages, hiddenPageIds);
    }, [match, hiddenPageIds, template?.pages]);

    const previousAvailablePageId = useMemo(() => {
        if (!match) {
            return null;
        }
        const pageId = match ? match.params.pageId : null;
        return findPreviousAvailablePageId(pageId, template?.pages, hiddenPageIds);
    }, [match, hiddenPageIds, template?.pages]);

    const onContinue = useCallback(() => onContinueProp(nextAvailablePageId), [onContinueProp, nextAvailablePageId]);
    const onBack = useCallback(() => onBackProp(previousAvailablePageId), [onBackProp, previousAvailablePageId]);

    return (
        <div>
            <IconButton color="secondary"
                disabled={!previousAvailablePageId || disableNavigation}
                className={classes.navButtonSpacing}
                title={intl.formatMessage({ id: 'inquiryPrevious' })}
                aria-label={intl.formatMessage({ id: 'inquiryPrevious' })}
                onClick={onBack}
            >
                <Icon name="chevron-left" dir={localeDirection ?? 'ltr'} />
            </IconButton>
            <IconButton color="secondary"
                disabled={!nextAvailablePageId || disableNavigation}
                className={classes.navButtonSpacing}
                onClick={onContinue}
                title={intl.formatMessage({ id: 'inquiryNext' })}
                aria-label={intl.formatMessage({ id: 'inquiryNext' })}
            >
                <Icon name="chevron-right" dir={localeDirection ?? 'ltr'} />
            </IconButton>
        </div>
    );
};
export default InquiryNavigation;
